import React from "react";
import { Tag, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { ReactComponent as TakeoutIcon } from "../assets/takout.svg";
import { ReactComponent as FilterIcon } from "../assets/filter.svg";
import { ReactComponent as OfferIcon } from "../assets/dollar.svg";

import "./HeaderCarousel.scss"

const cuisineMenu = (
  <Menu
    items={[
      { key: "1", label: "Indian" },
      { key: "2", label: "Italian" },
      { key: "3", label: "Chinese" },
    ]}
  />
);

const ratingMenu = (
  <Menu
    items={[
      { key: "1", label: "4.5+" },
      { key: "2", label: "4.0+" },
      { key: "3", label: "3.5+" },
    ]}
  />
);

const feeMenu = (
  <Menu
    items={[
      { key: "1", label: "Under $3" },
      { key: "2", label: "Under $5" },
      { key: "3", label: "Free" },
    ]}
  />
);

const FilterBar: React.FC = () => {
  return (
    <div className="filter-bar">
      <Tag className="filter-tag">
        <TakeoutIcon className="tag-icon" />
        Takeout
      </Tag>

      <Tag className="filter-tag">
        <FilterIcon className="tag-icon" />
        Filter
      </Tag>

      <Tag className="filter-tag">
        <OfferIcon className="tag-icon" />
        Offers
      </Tag>

      <Dropdown overlay={cuisineMenu} trigger={["click"]}>
        <Tag className="filter-tag dropdown-tag">
          Cuisine <DownOutlined className="down-icon" />
        </Tag>
      </Dropdown>

      <Dropdown overlay={ratingMenu} trigger={["click"]}>
        <Tag className="filter-tag dropdown-tag">
          Over 4.5 <DownOutlined className="down-icon" />
        </Tag>
      </Dropdown>

      <Dropdown overlay={feeMenu} trigger={["click"]}>
        <Tag className="filter-tag dropdown-tag">
          Delivery Fee: Under $3 <DownOutlined className="down-icon" />
        </Tag>
      </Dropdown>

      <Tag className="filter-tag">Under 30 minute</Tag>
    </div>
  );
};

export default FilterBar;
